import { XIcon } from "lucide-react";
import { useId } from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useTranslations } from "../../i18n";
import { clsx } from "clsx";
import { IconButton } from "../Button/IconButton";
import { Typography } from "../Typography";
import { useDrawerContext } from "./context";

export const DrawerContent = () => {
  const {
    title,
    description,
    footer,
    children,
    handleDismiss,
    showClose,
    side,
    open,
    className,
    preventClose,
    floatingContext,
    getFloatingProps,
    handleAnimationEnd,
    mounted,
    visible,
    accessory,
  } = useDrawerContext();

  const { t } = useTranslations();
  const titleId = useId();
  const descriptionId = useId();
  const isMobile = useMediaQuery("(max-width: 639px)");

  const effectiveSide = isMobile ? "bottom" : side || "right";

  const containerClasses = clsx(
    "nuco-drawer__container",
    `nuco-drawer__container--${effectiveSide}`,
    visible && mounted
      ? "nuco-drawer__container--visible"
      : "nuco-drawer__container--hidden",
    className,
  );

  return (
    <div
      ref={floatingContext.refs.setFloating}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? titleId : undefined}
      aria-describedby={description ? descriptionId : undefined}
      data-state={open ? "open" : "closed"}
      data-side={effectiveSide}
      className={containerClasses}
      onTransitionEnd={handleAnimationEnd}
      tabIndex={-1}
      {...getFloatingProps()}
    >
      {(title || description) && (
        <header data-drawer-header className="nuco-drawer__header">
          <div className="nuco-drawer__header-content">
            {title && (
              <Typography
                id={titleId}
                as="h3"
                variant="h3"
                weight="bold"
                className="nuco-drawer__title"
                text={title}
              />
            )}
            {description && (
              <Typography
                id={descriptionId}
                as="div"
                variant="headline"
                className="nuco-drawer__description"
                text={description}
              />
            )}
          </div>
          <div className="nuco-drawer__buttons">
            {accessory}
            {showClose !== false && !preventClose && (
              <IconButton
                variant="ghost"
                color="layer1"
                size="md"
                onClick={handleDismiss}
                aria-label={t("ui.drawer.closeLabel")}
              >
                <XIcon />
              </IconButton>
            )}
          </div>
        </header>
      )}
      <div data-drawer-body className="nuco-drawer__body">
        {children}
      </div>
      {footer && (
        <footer data-drawer-footer className="nuco-drawer__footer">
          {footer}
        </footer>
      )}
    </div>
  );
};
